<template lang="pug">
    .landingpage
        .section(v-if="sections.length" v-for="(section, index) in sections" :key="section.id" :class="section.key")
            Heading(
                v-if="section.key === 'heading'" :section="section"
                heading-class="is-size-2-desktop is-size-3-tablet is-size-4-mobile has-text-weight-light"
                sub-heading-class="is-size-6 is-uppercase has-text-primary"
            )
            Slider(v-if="section.key === 'slider'" :section="section")
            CategoryPosts(
                v-if="section.key === 'categoryposts'"
                :section="section"
                :per-page="3"
                orientation="horizontal"
            )
            Banners(v-if="section.key === 'banners'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
            Collage(v-if="section.key === 'mit-collage'" :section="section")
</template>

<script>

// import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Slider from '@/components/Slider'
import Collage from '@/components/Collage'
import CategoryPosts from '@/components/CategoryPosts'
import Banners from '@/components/Banners'
import Post from '@/components/Post'

export default {
    name: 'LandingPage',
    components: {
        Heading,
        ImageSection,
        Slider,
        Collage,
        CategoryPosts,
        Banners,
        Post,
    },
    computed: {
        ...mapGetters('currentPage', {
            sections: 'sections',
        })
    },
    methods: {
        ...mapMutations({
            updateHeaderVisibility: 'updateHeaderVisibility',
        })
    },
    mounted() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth > 1022) {
            this.updateHeaderVisibility(true);
        } else {
            this.updateHeaderVisibility(false);
        }

        window.addEventListener('resize', this.checkPerPage);
    }
}

</script>

<style lang="sass" scoped>
    .section.post .content
        padding-bottom: 20px
        border-bottom: 1px solid #ccc


    .section.slider,
    .section.banners,
    .section.mit-collage
        padding: 0
    .section.heading
        padding-bottom: 0
</style>
